// extracted by mini-css-extract-plugin
module.exports = {"fadeInUpBox":"style_fadeInUpBox___Zxmm","visible":"style_visible__6xk04"};